// extracted by mini-css-extract-plugin
export default {"image":"ImageViewer_image__RRDQj"};